import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { get, includes } from 'lodash';
import PaymentSourceSelector from '../../components/commit-form/payment-source-selector';
import CardFields from '../../components/commit-form/card-fields';
import {
  FORM_NAME as COMMIT_FORM_NAME,
} from '../../components/commit-form/index';
import Purchase from '../../lib/purchase';
import { fetchUserPaymentSources } from '../../actions';
import { getCurrentUserMembership } from '../../selectors/purchase-selector';

import { getCurrentUser } from '../../selectors/user-selector';
import { getCurrentPurchase } from '../../selectors/purchase-selector';
import {
  isExpired,
  initializeSpreedly,
  initializeYourPay,
  disabledCardFields,
} from '../../lib/card-functions';
import {
  SPREEDLY_PLATFORM_TYPE,
  YOURPAY_PLATFORM_TYPE,
} from '../../lib/card-type-names';

const env = global.pbgEnv;
const { REACT_APP_SPREEDLY_KEY } = env;

class PaymentSourceSelectorContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNewCardFields: !this.validPaymentSources.length,
      cardFieldsDirty: false,
    };

    this.onPaymentSourceChange = this.onPaymentSourceChange.bind(this);
    this.cardTokenized = this.props.cardTokenized.bind(this);
    this.onCardFieldsTouched = this.onCardFieldsTouched.bind(this);
  }


  get isFailedMembership() {
    return get(this.props, 'currentMembership.failed', false);
  }

  get isCurrentPaymentSourceValid() {
    const paymentSource = get(this.props, 'currentMembership.paymentSource');
    return this.isValidPaymentSource(paymentSource);
  }

  get isValidDefaultPaymentSource() {
    const defaultPaymentSource = get(this.props, 'currentUser.defaultPaymentSource');
    return this.isValidPaymentSource(defaultPaymentSource);
  }

  get paymentPlatform() { return this.props.purchase.paymentPlatform; }

  get cardFieldsConfig() {

    if (this.paymentPlatform.type === SPREEDLY_PLATFORM_TYPE) {
      return { spreedlyKey: REACT_APP_SPREEDLY_KEY };
    } else if (this.paymentPlatform.type === YOURPAY_PLATFORM_TYPE) {
      return this.paymentPlatform.config;
    }
  }

  get cardFieldsInitializer() {
    if (this.paymentPlatform.type === SPREEDLY_PLATFORM_TYPE) {
      return config => initializeSpreedly(config);
    } else if (this.paymentPlatform.type === YOURPAY_PLATFORM_TYPE) {
      return config => initializeYourPay(config);
    }
  }

  get validCardTypes() {
    const { purchase: { currencyConfig } } = this.props;
    return Purchase.getValidCardTypes(currencyConfig);
  }

  get validPaymentSources() {
    const { paymentSources } = this.props;
    const valid = paymentSources.filter((source) => {
      return source.platform.id === this.paymentPlatform.id &&
        includes(Object.keys(this.validCardTypes), source.info.cardType) &&
        !isExpired(source.info.validUntil);
    }).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    return valid;
  }

  componentWillMount() {
    const { paymentSources, currentUser, authentication } = this.props;
    if (!paymentSources.length && currentUser) {
      this.props.fetchUserPaymentSources(currentUser, authentication.token);
    } else {
      this.setDefaultPaymentSource(this.validPaymentSources || []);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentUser && !nextProps.currentUser) {
      this.changePaymentSourceId('new');
    }

    if (!this.props.currentUser && nextProps.currentUser) {
      const { authentication, currentUser } = nextProps;
      this.props.fetchUserPaymentSources(currentUser, authentication.token);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.paymentSources.length !== this.props.paymentSources.length) {
      this.setState({ showNewCardFields: !this.validPaymentSources.length });
      if (!this.state.cardFieldsDirty) {
        this.setDefaultPaymentSource(this.validPaymentSources);
      }
    }
  }

  onPaymentSourceChange(val) {
    if (val === 'new') {
      this.showNewCardFields();
      this.changePaymentSourceId('new');
    } else {
      this.hideNewCardFields();
      this.setState({ cardFieldsDirty: false });
    }
  }

  onCardFieldsTouched() {
    if (!this.state.cardFieldsDirty) {
      this.setState({ cardFieldsDirty: true });
    }
  };

  isValidPaymentSource(paymentSource) {
    const validType = !!paymentSource && includes(this.validCardTypes, paymentSource.info.cardType);
    const notExpired = !!paymentSource && !isExpired(paymentSource.info.validUntil);
    return validType && notExpired;
  }

  setDefaultPaymentSource(paymentSources) {
    const { currentMembership, currentUser } = this.props;

    if (this.isFailedMembership || !this.validPaymentSources.length) {
      this.changePaymentSourceId('new');
      return this.showNewCardFields();
    }

    if (this.isCurrentPaymentSourceValid) {
      return this.changePaymentSourceId(currentMembership.paymentSource.id);
    }

    if (this.isValidDefaultPaymentSource) {
      return this.changePaymentSourceId(currentUser.defaultPaymentSource.id);
    }

    this.changePaymentSourceId('new');
    this.showNewCardFields();
  }

  changePaymentSourceId(value) {
    this.props.change(this.props.formName || COMMIT_FORM_NAME, 'card.paymentSourceId', value);
  }

  hideNewCardFields() { this.setState({ showNewCardFields: false }); }

  showingNewCardFields() {
    return this.state.showNewCardFields || this.state.cardFieldsDirty;
  }

  showNewCardFields() { this.setState({ showNewCardFields: true }); }

  render() {
    const { merchant, purchase: { currencyConfig } } = this.props;
    const components = [];

    if (this.validPaymentSources.length) {
      components.push(<PaymentSourceSelector
        key="payment-sources-selector"
        onChange={this.onPaymentSourceChange}
        validCardTypes={this.validCardTypes}
        paymentSources={this.validPaymentSources}
        purchase={this.props.purchase}
      />);
    }

    if (this.showingNewCardFields()) {
      components.push(<CardFields
        key="card-fields"
        initializer={this.cardFieldsInitializer}
        config={this.cardFieldsConfig}
        disabledFields={disabledCardFields(merchant)}
        cardTokenized={this.cardTokenized}
        onCardError={this.props.cardError}
        currencyConfig={currencyConfig}
        onCardFieldsTouched={this.onCardFieldsTouched}
      />);
    }

    return (
      <div className="payment-sources-form">
        {components}
      </div>
    );
  }
}

const mapSateToProps = (state, props) => {
  const currentUser = getCurrentUser(state);
  const purchase = getCurrentPurchase(state);

  return {
    currentUser,
    purchase,
    merchant: purchase.merchant,
    currentMembership: getCurrentUserMembership(state),
    authentication: state.session.authentication,
    paymentSources: get(currentUser, 'paymentSources', []),
  };
};

const mapDispatchToProps = {
  fetchUserPaymentSources,
  change,
};

export default connect(mapSateToProps, mapDispatchToProps)(PaymentSourceSelectorContainer);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/payment-source-selector.container.js